module.exports = __webpack_public_path__ + "cloud-security.kYtJy8iC.svg";